import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./homePage/Home"; // Create this page
//who we are imports
import About from "./whoWeAre/AboutUs"; // Create this page
import Responsibility from "./whoWeAre/CorporateResponsibility";
import MBSStrategicPlan from "./whoWeAre/MBSStrategicPlan";
import MBSManagement from "./whoWeAre/MBSManagement";

import StaffLogin from "./pages/StaffLogin";
import StaffDashboard from "./pages/StaffDashboard";
import AccessToInformationManual from "./pages/accessToInformationManual";

//what we do imports
import StandardsServices from "./whatWeDo1/StandardsServices";
import DevelopmentofMalawiStandards from "./whatWeDo1/DevelopmentofMalawiStandards";
import TestingServices from "./whatWeDo1/TestingServices";
import IndustrialResearchandTraining from "./whatWeDo1/IndustrialResearchandTraining.js";
import InquiryPoint from "./whatWeDo1/InquiryPoint.js";
import InspectorateServices from "./whatWeDo1/InspectorateServices.js";
import ManagementSystemsCertification from "./whatWeDo1/ManagementSystemsCertification.js";
import ProductandServiceCertification from "./whatWeDo1/ProductandServiceCertification.js";
import StandardsLevy from "./whatWeDo1/StandardsLevy.js";
import VerificationandCalibration from "./whatWeDo1/VerificationandCalibration.js";
import NavigationBar from "./homePage/NavigationBar";
import Footer from "./homePage/footer";
import Careers from "./homePage/careers.js";
import StandardsCatalogue from "./standardsCatalogue/StandardsCatalogue";
import CustomerService from "./whatWeDo1/ServiceCharter.js";
import ComplaintsHandling from "./whatWeDo1/ComplaintsHandling.js";
import MediaPublications from "./whatWeDo1/MediaPublications.js";
import AccessToInformation from "./whatWeDo1/AccessToInformation.js"; 
import MBSSICmembershischeme from "./whatWeDo1/MBSSICmembershischeme.js"; 
import ContactUs from "./whatWeDo1/ContactUs.js";


import TechnicalCommitees from "./whatWeDo1/TechnicalCommitees.js";
import SACListOfApprovedStandards from "./whatWeDo1/SACListOfApprovedStandards.js";
import IndustrialResearchTraining from "./whatWeDo1/IndustrialResearchandTraining.js";
import StandardsProposedForAdoption from "./whatWeDo1/StandardsProposedForAdoption.js";
import StandardsUnderPublicReview from "./whatWeDo1/StandardsUnderPublicReview.js";
import StandardsUnderSystematicReview from "./whatWeDo1/StandardsUnderSystematicReview.js";
import TechnicalCommitteeFeedback from "./whatWeDo1/TechnicalCommitteeFeedback.js";
import TestingLaboratories from "./whatWeDo1/TestingLaboratories.js";
import CallForCommentsOnDraft from "./whatWeDo1/CallForCommentsOnDraft.js";
import ApplicationForTC from "./whatWeDo1/ApplicationForTC.js";
import AfricaQualityPolicy from "./whatWeDo1/AfricaQualityPolicy.js";

import CatalogueOfMalawiStandards from "./whatWeDo1/CatalogueOfMalawiStandards.js";
import CertificationBody from "./whatWeDo1/CertificationBody.js";
import CertificationSchemes from "./whatWeDo1/CertificationSchemes.js";
import CertificationSteps from "./whatWeDo1/CertificationSteps.js";
import CertificationPolicies from "./whatWeDo1/CertificationPolicies.js";
import CertificationFirms from "./whatWeDo1/CertificationFirms.js";
import ManagementSystemsAuditor from "./whatWeDo1/ManagementSystemsAuditor.js";
import AuditorConfidentiality from "./whatWeDo1/AuditorConfidentiality.js";
import NationalQualityInstitute from "./whatWeDo1/NationalQualityInstitute.js";

import NQICallForProposals from "./whatWeDo1/NQICallForProposals2024.js";
import ResearchFunction from "./whatWeDo1/ResearchFunction.js";
import MalawiQualityAwards from "./whatWeDo1/MalawiQualityAwards.js";
import ExtensionServices from "./whatWeDo1/ExtensionServices.js";
import NQITrainingCalendar from "./whatWeDo1/NQITrainingCalendar.js";
import NQIFeedbackForm from "./whatWeDo1/NQIFeedbackForm.js";
import CQPProgram from "./whatWeDo1/CQPProgram.js";
import TrainingServices from "./whatWeDo1/TrainingServices.js";
import MembershipScheme from "./whatWeDo1/MembershipScheme.js";

import METLIMSAccountRequest from "./whatWeDo1/METLIMSAccountRequest.js";
import AccreditationCertification from "./whatWeDo1/AccreditationCertification.js";
import MetrologyTraining from "./whatWeDo1/MetrologyTraining.js";
import MetrologyServices from "./whatWeDo1/MetrologyServices.js";

import TestingOtherServices from "./whatWeDo1/testingOtherServices.js";

import Survey2024 from "./whatWeDo1/Survey2024.js";
import IMpartialityAssessment from "./whatWeDo1/IMpartialityAssessment.js";
import MarketSurveillance from "./whatWeDo1/MarketSurveillance.js";
import MarketSurveillanceComplaints from "./whatWeDo1/MarketSurveillanceComplaints.js";

import QualityManagement from "./whatWeDo1/QualityManagement.js";

import InformationOfficers from "./whatWeDo1/InformationOfficers.js";

import LegislationDocuments from "./whatWeDo1/LegislationDocuments.js"; 
import WTOTBTSPSNationalEnquiryPoint from "./whatWeDo1/WTOTBTSPSNationalEnquiryPoint.js";

import OtherDocuments from "./whatWeDo1/OtherDocuments.js";
//first row pages imports
import Procurement from "./firstRowPages/Procurement.js";
import PublicNotices from "./firstRowPages/PublicNotices.js";
import NationalCodex from "./firstRowPages/NationalCodex.js";
import Alerts from "./firstRowPages/Alerts.js";

function App() {
  return (
    <Router>
      <NavigationBar />

      <Routes>
        <Route path="/" element={<Home />} /> 
        <Route path="/careers" element={<Careers />} /> 
        
        <Route path="/staff-tools" element={<StaffLogin />} />
        <Route path="/staff-tools/dashboard" element={<StaffDashboard />} />
        
        <Route path="/CatalogueOfMalawiStandards" element={<CatalogueOfMalawiStandards />} />

        <Route path="/accessToInformationManual" element={<AccessToInformationManual />} />

        <Route path="/WTOTBTSPSNationalEnquiryPoint" element={<WTOTBTSPSNationalEnquiryPoint />} />
        <Route path="/MBSSICmembershischeme" element={<MBSSICmembershischeme />} />
        <Route path="/QualityManagement" element={<QualityManagement />} />
        <Route path="/DevelopmentofMalawiStandards" element={<DevelopmentofMalawiStandards />} />
        <Route
          path="/Management_Systems_Certification_Scheme"
          element={<Survey2024 />}
        />
        <Route
          path="/Exports_Quality_Monitoring_Scheme"
          element={<IMpartialityAssessment />}
        />
        <Route path="/permit_scheme" element={<MarketSurveillance />} />
        <Route
          path="/overviewIandC"
          element={<MarketSurveillanceComplaints />}
        />

        <Route
          path="/testingOtherServices"
          element={<TestingOtherServices />}
        />

 <Route path="/mediaPublications/:storyId" element={<MediaPublications />} />   

        <Route
          path="/standards_information_centre"
          element={<StandardsUnderSystematicReview />}
        />
        <Route
          path="/METLIMSAccountRequest"
          element={<METLIMSAccountRequest />}
        />
        <Route
          path="/AccreditationCertification"
          element={<AccreditationCertification />}
        />
        <Route path="/MetrologyTraining" element={<MetrologyTraining />} />
        <Route path="/MetrologyServices" element={<MetrologyServices />} />

        <Route path="/NQICallForProposals" element={<NQICallForProposals />} />
        <Route path="/ResearchFunction" element={<ResearchFunction />} />
        <Route path="/MalawiQualityAwards" element={<MalawiQualityAwards />} />
        <Route path="/ExtensionServices" element={<ExtensionServices />} />
        <Route path="/NQITrainingCalendar" element={<NQITrainingCalendar />} />
        <Route path="/NQIFeedbackForm" element={<NQIFeedbackForm />} />
        <Route path="/CQPProgram" element={<CQPProgram />} />
        <Route path="/TrainingServices" element={<TrainingServices />} />
        <Route path="/MembershipScheme" element={<MembershipScheme />} />

        <Route
          path="/national_quality_institute"
          element={<NationalQualityInstitute />}
        />
        <Route
          path="/auditor_confidentiality"
          element={<AuditorConfidentiality />}
        />
        <Route
          path="/management_systems_auditor"
          element={<ManagementSystemsAuditor />}
        />
        <Route path="/certification_firms" element={<CertificationFirms />} />
        <Route
          path="/certification_policies"
          element={<CertificationPolicies />}
        />
        <Route path="/certification_steps" element={<CertificationSteps />} />
        <Route
          path="/certification_schemes"
          element={<CertificationSchemes />}
        />
        <Route path="/certification_body" element={<CertificationBody />} />
        <Route
          path="/offices_and_staffing"
          element={<SACListOfApprovedStandards />}
        />
        <Route
          path="/IndustrialResearchTraining"
          element={<IndustrialResearchTraining />}
        />
        <Route
          path="/designation_scheme"
          element={<StandardsProposedForAdoption />}
        />
        <Route
          path="/StandardsUnderPublicReview"
          element={<StandardsUnderPublicReview />}
        />
        <Route path="/DISMembership" element={<TechnicalCommitteeFeedback />} />
        <Route path="/TestingLaboratories" element={<TestingLaboratories />} />
        <Route
          path="/Imports_Quality_Monitoring_Scheme"
          element={<CallForCommentsOnDraft />}
        />
        <Route path="/ApplicationForTC" element={<ApplicationForTC />} />
        <Route
          path="/consumer_complaints_handling"
          element={<AfricaQualityPolicy />}
        />

        {/* routes for who we are */}
        <Route path="/about" element={<About />} />
        <Route path="/responsibility" element={<Responsibility />} />
        <Route path="/mbsstrategicplan" element={<MBSStrategicPlan />} />
        <Route path="/mbsmanagement" element={<MBSManagement />} />
        {/* routes for what we do */}
        <Route path="/Overview" element={<StandardsServices />} />
        <Route path="/testingServices" element={<TestingServices />} />
        <Route path="/mediaPublications" element={<MediaPublications />} />
        <Route path="/accessToInformation" element={<AccessToInformation />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/complaintsHandling" element={<ComplaintsHandling />} />
        <Route path="/technicalCommittees" element={<TechnicalCommitees />} />

        <Route
          path="/industrialResearchandTraining"
          element={<IndustrialResearchandTraining />}
        />
        <Route path="/inquiryPoint" element={<InquiryPoint />} />
        <Route
          path="/inspectorateServices"
          element={<InspectorateServices />}
        />
        <Route
          path="/managementSystemsCertification"
          element={<ManagementSystemsCertification />}
        />

        <Route path="/customerService" element={<CustomerService />} />

        <Route
          path="/productandServiceCertification"
          element={<ProductandServiceCertification />}
        />
        <Route path="/standardsLevy" element={<StandardsLevy />} />
        <Route
          path="/verificationandCalibration"
          element={<VerificationandCalibration />}
        />
        <Route path="/standardsCatalogue" element={<StandardsCatalogue />} />

        <Route path="/informationOfficers" element={<InformationOfficers />} />
        <Route
          path="/legislationDocuments"
          element={<LegislationDocuments />}
        />
        <Route path="/otherDocuments" element={<OtherDocuments />} />

        <Route path="/procurement" element={<Procurement />} />
        <Route path="/nationalCodex" element={<NationalCodex />} />
        <Route path="/publicNotices" element={<PublicNotices />} />
        <Route path="/alerts" element={<Alerts />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
